import React, { useState } from "react";
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Fab } from "@material-ui/core";
import { Menu as MenuIcon, Person as AccountIcon, Send as SendIcon, ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import classNames from "classnames";
// styles
import useStyles from "./styles";


// components
import { Typography } from "../Wrappers";

import UserAvatar from "../UserAvatar/UserAvatar";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../Context/LayoutContext";
import { useUserDispatch, signOut } from "../../Context/UserContext";
import logoEqut from './logoequt.png'
const messages = [
  {
    id: 0,
    variant: "warning",
    name: "Jane Hew",
    message: "Hey! How is it going?",
    time: "9:32",
  },
  {
    id: 1,
    variant: "success",
    name: "Lloyd Brown",
    message: "Check out my new Dashboard",
    time: "9:18",
  },
  {
    id: 2,
    variant: "primary",
    name: "Mark Winstein",
    message: "I want rearrange the appointment",
    time: "9:15",
  },
  {
    id: 3,
    variant: "secondary",
    name: "Liana Dutti",
    message: "Good news from sale department",
    time: "9:09",
  },
];

export default function Header(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();

  // local
  var [mailMenu, setMailMenu] = useState(null);
  var [profileMenu, setProfileMenu] = useState(null);
  var [isSearchOpen, setSearchOpen] = useState(false);

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButtonSandwich,
            classes.headerMenuButtonCollapse,
          )}
        >
          {layoutState.isSidebarOpened ? (
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )}
        </IconButton>
        <img
          src={logoEqut}
          alt="Equativ Logo"
          style={{height:28}}
        />


        <div className={classes.grow} />
        
        <div
          className={classNames(classes.search, {
            [classes.searchFocused]: isSearchOpen,
          })}
        >
          <div
            className={classNames(classes.searchIcon, {
              [classes.searchIconOpened]: isSearchOpen,
            })}
            onClick={() => setSearchOpen(!isSearchOpen)}
          >
           
          </div>
          
        </div>
        


        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="profile-menu"
          onClick={e => setProfileMenu(e.currentTarget)}
        >
          {(() => {
        if (localStorage.getItem("imageUrl")) {
          return (
            
            <img
              src={localStorage.getItem("imageUrl")}
              alt="User avatar"
              style={{ width: "45px", height: "45px", borderRadius: "50px" }}
            />
            )
          } 
        })()}
                  {(() => {
        if (!localStorage.getItem("imageUrl")) {
          document.cookie = "Logincookie; expires=" + new Date(0).toUTCString();
          localStorage.removeItem('email');
          localStorage.removeItem('imageUrl');
          localStorage.removeItem('name');
          //signOut(userDispatch, props.history);
          return (
            <AccountIcon classes={{ root: classes.headerIcon }} />
            )
          } 
        })()}

         
        </IconButton>
        <Menu
          id="mail-menu"
          open={Boolean(mailMenu)}
          anchorEl={mailMenu}
          onClose={() => setMailMenu(null)}
          MenuListProps={{ className: classes.headerMenuList }}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
           
          </div>
          {messages.map(message => (
            <MenuItem key={message.id} className={classes.messageNotification}>
              <div className={classes.messageNotificationSide}>
                <UserAvatar color={message.variant} name={message.name} />
                <Typography size="sm" color="text" colorBrightness="secondary">
                  {message.time}
                </Typography>
              </div>
              <div
                className={classNames(
                  classes.messageNotificationSide,
                  classes.messageNotificationBodySide,
                )}
              >
                
              </div>
            </MenuItem>
          ))}
          <Fab
            variant="extended"
            color="primary"
            aria-label="Add"
            className={classes.sendMessageButton}
          >
            Send New Message
            <SendIcon className={classes.sendButtonIcon} />
          </Fab>
        </Menu>
        
        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          
          <div className={classes.profileMenuUser}>
          {(() => {
        if (localStorage.getItem("name")) {
          return (
            <Typography
            className={classes.profileMenuLink}
            color="black"
          >
            Hello, {localStorage.getItem("name")}
          </Typography>
            )
          } 
        })()}
            <Typography
              className={classes.profileMenuLink}
              color="primary"
              onClick={() => {signOut(userDispatch, props.history);document.cookie = "Logincookie; expires=" + new Date(0).toUTCString();}}
            ><br></br>
              Log out
            </Typography>
          </div>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
